
@if (context.offer.reserved) {
  <span edButton class="e-buy-now e--reserved">
          <span class="e-reserve-label" i18n>Reserviert</span>
          <app-tooltip i18n>
            Diese Domain wurde bereits reserviert und kann zurzeit nicht erworben werden
          </app-tooltip>
      </span>
} @else {
  @if (context.config.price) {
    <a
      edButton
      class="e-buy-now e--primary"
      [href]="context.links.checkout"
      i18n
    >
      Jetzt kaufen
    </a>
  }

  @if (context.config.template_data['price-suggest']) {
    <a
      class="e-price-suggest"
      [ngClass]="{'e--primary': !context.config.price}"
      [edButton]="{theme: context.config.price ? 'light' : 'default'}"
      (click)="openPriceSuggest()"
      i18n
    >
      Preis vorschlagen
    </a>
  }
}
